import * as React from 'react';

import { AccountInfoFormContent } from './AccountInfoFormContent';
import { ApplicantInfoFormContent } from './ApplicantInfoFormContent';
import { IdentityTypeFormContent } from './IdentityTypeFormContent';
import { type PeripheralProp, type FormikProp } from './types';
import { VIEW_MODE } from '../../../utils';

export type StepperContentProps = {
  activateStep: number;
  formik: FormikProp;
  peripheralProp: PeripheralProp;
};

export const StepperFormContent: React.FunctionComponent<
  StepperContentProps
> = (props: StepperContentProps) => {
  const { activateStep, formik, peripheralProp } = props;
  const getActivateContent = (
    activateStep: number,
  ): React.ReactElement | null => {
    switch (activateStep) {
      case 0:
        return (
          <AccountInfoFormContent
            formik={formik}
            peripheralProp={peripheralProp}
          />
        );
      case 1:
        return <IdentityTypeFormContent {...formik} />;
      case 2:
        return (
          <ApplicantInfoFormContent
            formik={formik}
            viewMode={VIEW_MODE.SIGN_UP}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full flex justify-center">
      {getActivateContent(activateStep)}
    </div>
  );
};
